export const EXPERIMENT = 'experiment';
export const RELEASE = 'release';
export const OPERATIONAL = 'operational';
export const KILLSWITCH = 'kill-switch';
export const PERMISSION = 'permission';
